import { useState, useEffect, useContext } 	from "react";
import { Card, CardContent, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"

import DashboardContext 	from "../context";
import { formatCurrency }	from "../../../common/Helper";
import LoadingCard 			from "./LoadingCard";

const DividendsCard = () => {
	const {portfolio, dividends, exchangeRates}	= useContext(DashboardContext)

	const [earningsSummary, setEarningsSummary]	= useState()

	useEffect(() => {
		
		if (dividends && exchangeRates) {
			let earningsSummaryList = [];

			const summarizeEarnings = (pType) => {
				const market 			= pType === 'ACAO' ? 'BR' : 'US'
				const name				= pType === 'ACAO' ? 'Ações' : 'Stocks'

				let currentExchangeRate	= pType === 'STOCK' ? exchangeRates.find(er => er.symbol === 'USDBRL')?.price : 1

				let currentEarnings		= dividends.filter(e => e.market === market).reduce((acc, e) => acc + parseFloat(e.earnings),0) * currentExchangeRate
				let monthEarnings 		= dividends.filter(e => e.market === market && e.month === new Date().getMonth()+1).reduce((acc, e) => acc + parseFloat(e.earnings),0) * currentExchangeRate
				let currentCost			= portfolio.filter(p => p.assetType === pType).reduce((acc, p) => acc + parseFloat(p.cost),0)

				return  ({
					name 		: name,
					total		: currentEarnings,
					month		: monthEarnings,
					yield		: ( currentEarnings / currentCost ) * 100 || 0
				})
			}

			earningsSummaryList.push(summarizeEarnings('ACAO'))
			earningsSummaryList.push(summarizeEarnings('STOCK'))

			setEarningsSummary(earningsSummaryList)
		}

	}, [dividends, exchangeRates])

	if (!dividends) return <LoadingCard/>

	return (
		<Card sx={{height: '100%'}}>
			<CardContent>
				<Typography variant="h6" align="center"> Dividendos </Typography>
				<Stack direction={'column'} spacing={1}>
					<TableContainer component={Paper}>
						<Table size="small">
							<TableHead >
								<TableRow>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}}> Tipo </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="left"> Total </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="left"> Mês </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Yield </TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{ earningsSummary && earningsSummary.map((asset) => (
									<TableRow key={"key_"+ asset.name}>
										<TableCell sx={{ fontSize: '0.65rem'}}>{asset.name}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="left">{formatCurrency(asset.total, 'SMALL')}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="left">{formatCurrency(asset.month, 'SMALL')}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{asset.yield.toFixed(2)} %</TableCell>
									</TableRow>
								))}
							</TableBody>

						</Table>
					</TableContainer>
				</Stack>
			</CardContent>
		</Card>
	)
}

export default DividendsCard